import React from 'react';
import { Grid } from '@material-ui/core';

/**
 * Render vertical line grid item
 * @returns {React.Component} The rendered `<VerticalGridItem />`
 * @memberof OrderDetailsComponent
 */
export const VerticalGridItem = ({ classes }) => {
  return (
    <Grid item>
      <div className={classes.detailsBoxItemBorder}>&nbsp;</div>
    </Grid>
  );
};

/**
 * Render Grid item with display as block !important
 * @returns {React.Component} The rendered `<Grid item />`
 * @memberof OrderDetailsComponent
 */
export const GridBlock = (props) => {
  return (
    <Grid item style={{ display: 'block !important' }} {...props}>
      {props.children}
    </Grid>
  );
}
